/* eslint-disable import/no-cycle, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call */
import { Checkbox, HStack, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { QuestionnaireTemplateStore } from '../../../store/questionnaireTemplateModel';

const path = `isSkippable`;
export const QuestionSkipQuestion = React.memo(function QuestionSkipQuestion({ elementId }: { elementId: string }) {
  const { t } = useTranslation('questionnaireTemplate');
  const valueSelector = React.useCallback((state) => state.getElementValue(elementId, path), [elementId]);
  const value = QuestionnaireTemplateStore.useStoreState(valueSelector);
  const updateValue = QuestionnaireTemplateStore.useStoreActions((actions) => actions.updateElementValue);

  const handleChange = React.useCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => {
      updateValue({ id: elementId, path, value: e.target.checked });
    },
    [elementId, updateValue],
  );
  return (
    <HStack py={4}>
      <Checkbox onChange={handleChange} isChecked={value}>
        <Text fontSize="sm">{t('formBuilder.canvas.element.documentUpload.skipQuestionLabel')}</Text>
      </Checkbox>
    </HStack>
  );
});
